export const getIdsOfItems = (hiredProduct, productType) => {
  const idsArray = [];
  // 1) mobiles
  const productHasMobile = productType === 0 || productType === 3;
  const productHasMobile1 = hiredProduct.mobile !== null;

  if (productHasMobile && productHasMobile1) {
    const { linesMobile } = hiredProduct.mobile;

    linesMobile.map((currentLines) => {
      const kindProduct = 'mobile';
      const res = {
        kindProduct,
        number: currentLines.number,
        productId: currentLines.productId,
      };

      idsArray.push(res);
      return null;
    });
  }
  // 2) internet
  const productHasInternet =
    productType === 0 || productType === 1 || productType === 2;
  const productHasInternet1 = hiredProduct.internet !== null;

  if (productHasInternet && productHasInternet1) {
    const kindProduct = 'internet';
    const res = {
      kindProduct,
      productId: hiredProduct.internet.productId,
    };

    idsArray.push(res);
  }
  // phone
  const productHasPhone =
    (productType >= 0 && productType < 3) || productType === 4;
  const productHasPhone1 = hiredProduct.phone !== null;

  if (productHasPhone && productHasPhone1) {
    const { linesPhone } = hiredProduct.phone;

    linesPhone.map((currentLines) => {
      const kindProduct = 'phone';
      const res = {
        kindProduct,
        number: currentLines.number,
        productId: currentLines.productId,
      };

      idsArray.push(res);
      return null;
    });
  }
  // tv ¿y el trio?
  const productHasTv = productType === 0;
  const productHasTv1 = hiredProduct.tv !== null;

  if (productHasTv && productHasTv1) {
    const kindProduct = 'tv';
    const res = {
      kindProduct,
      productId: hiredProduct.tv.productId,
    };

    idsArray.push(res);
  }
  return idsArray;
};

export const getAllDataItems = (hiredProduct) => {
  const idsArray = getIdsOfItems(hiredProduct, hiredProduct.productType);

  return idsArray;
};

export const normalizeGetMyProductsResponse = (myProducts) => {
  const myProductsNew = [];

  myProducts.forEach((product) => {
    const newProductObj = product;

    let newLinesMobile = null;

    if (product.mobile && product.mobile.linesMobile) {
      newLinesMobile = product.mobile.linesMobile.map((itemMobile) => {
        const newItemLineMobile = itemMobile;

        newItemLineMobile.main = false;
        return newItemLineMobile;
      });
    }
    if (newLinesMobile) {
      newProductObj.mobile.linesMobile = newLinesMobile;
    }
    const ids2Add = getAllDataItems(product);
    const newProduct = newProductObj;

    newProduct.childProductId = ids2Add;

    myProductsNew.push(newProduct);
  });
  return myProductsNew;
};

export const normalizeGetMyLinesResponse = (myProducts) => {
  const lines = {
    linesMobile: [],
    linesPhone: [],
  };

  myProducts.forEach((product) => {
    /* valores de productType:
          0 = Fusión (internet, fijo, televisión y líneas móviles).
          1 = Trío (internet, fijo y televisión).
          2 = Dúo (internet y televisión).
          3 = Sólo línea móvil.
          4 = Sólo terminal.
      */
    switch (product.productType) {
      case 0: {
        product.phone.linesPhone.forEach((line) => {
          line.productType = product.productType;
          lines.linesPhone.push(line);
        });
        // Sólo obtenemos la línea móvil más antigua
        let oldLineMobile = product.mobile.linesMobile[0];

        product.mobile.linesMobile.forEach((line) => {
          if (new Date(oldLineMobile.startDate) > new Date(line.startDate)) {
            oldLineMobile = line;
          }
        });
        oldLineMobile.productType = product.productType;
        lines.linesMobile.push(oldLineMobile);
        break;
      }
      case 1:
      case 2:
        product.phone.linesPhone.forEach((line) => {
          line.productType = product.productType;
          lines.linesPhone.push(line);
        });
        break;
      case 3:
        product.mobile.linesMobile.forEach((line) => {
          line.productType = product.productType;
          lines.linesMobile.push(line);
        });
        break;
      default:
        break;
    }
  });
  return lines;
};
